import store from './store/store';

export default {
    items: [
        /*{
      lang_key: 'dashboard',
      name: 'Resumen',
      url:  '/dashboard',
      icon: 'icon-speedometer',
    },*/
        {
            lang_key: "companies",
            name: "Compañías",
            url: "/companies",
            icon: "fa fa-building-o",
        },
        {
            lang_key: "map",
            name: "Mapa",
            url: "/map",
            icon: "icon-map",
        },

        {
            lang_key: "orders",
            name: "Órdenes",
            icon: "icon-bag",
            url: "/order-management/search-status=",
            children: [
                /*{
          name: store.getState().json_lang.dashboard.all,
        },*/
                {
                    name: store.getState().json_lang.order_status.canceled,
                },
                {
                    name: store.getState().json_lang.order_status.delivered,
                },
                {
                    name: store.getState().json_lang.order_status.in_progress,
                },
                {
                    name: store.getState().json_lang.order_status.arrived,
                },
                {
                    name: store.getState().json_lang.order_status.ready,
                },
                {
                    name: store.getState().json_lang.order_status.on_the_way,
                },
                {
                    name: store.getState().json_lang.order_status.delayed,
                },
                {
                    name: store.getState().json_lang.order_status.scheduled,
                },
                {
                    name: store.getState().json_lang.order_status.confirmed,
                },
                {
                    name: store.getState().json_lang.order_status
                        .payment_pending,
                },
                {
                    name: store.getState().json_lang.order_status
                        .payment_to_validate,
                },
                {
                    name: store.getState().json_lang.order_status.unconfirmed,
                },
            ],
        },
        /*{
        lang_key: 'providers',
        name: 'Proveedores',
        url:  '/provider-management',
        icon: 'fa fa-motorcycle',
      },
      {
        lang_key: 'clients',
        name: 'Clientes',
        url:  '/clients-management',
        icon: 'icon-people',
      },
      {
        lang_key: 'attributes',
        name: 'Características',
        url:  '/properties-management',
        icon: 'icon-tag',
  	},*/
        {
            lang_key: "goods",
            name: "Productos",
            url: "/goods-management",
            icon: "icon-book-open",
        },
        /*{
      lang_key: 'eta',
      name: 'Eta',
      url:  '/eta',
      icon: 'icon-book-open',
    },
    {
      lang_key: 'branch_goods',
      name: 'Productos de Sucursal',
      url:  '/goods-management/branch',
      icon: 'icon-book-open',
    },*/
        {
            lang_key: "categories",
            name: "Categorías",
            url: "/categories-management",
            icon: "icon-list",
        },
        {
            lang_key: "admins",
            name: "Administradores",
            url: "/admins-management",
            icon: "icon-organization icons",
        },
        {
            lang_key: "billing",
            name: "Mis cobros",
            //url:  '/company-billings',
            url: "/company-charges",
            icon: "icon-wallet",
        },
        {
            lang_key: "company",
            name: "Configuración",
            url: "/settings",
            icon: "icon-settings",
        },
        /* {
            name: "Services Supplier (Alpha)",
            url: "/service-suppliers",
        },
        {
            name: "Fleets (Alpha)",
            url: "/fleets",
        }, */
        {
            lang_key: "reports",
            name: "Reports",
            url: "/reports",
            icon: "fa fa-print",
        },
        /*{
      lang_key: 'banners',
      name: 'Banners',
      url:  '/banners',
      icon: '',
    },*/
        /*{
      lang_key: 'billing',
      name: 'Finanzas',
      url:  '/company-billings',
      icon: 'icon-wallet',
    }, */
    ],
};



// WEBPACK FOOTER //
// ./src/_navSuper_es.js